enum TypeInfo {
    Product = "Product",
    Delivery = "Delivery"
}

export default TypeInfo;